import React from 'react'
import styles from '../BlocksPage/index.module.sass'
import classNames from 'classnames'
import {
    getTimeFromTimestamp,
    processedStringFromApi,
    round,
    stringTruncateFromCenter,
    stringTruncateFromLeft,
} from '../../../utils'

import { Transaction } from '../../../app/models/generated'
import { NavLink } from 'react-router-dom'
import { Icon } from '../../ui/Icon'
import { TypeOfTransaction } from '../../ui/TypeOfTransaction'
import { Status } from '../../ui/Status'

interface wrapperTransaction {
    transaction: Transaction
}

export const ProducedBlockItem = (props: wrapperTransaction) => {
    const currentTransaction = props.transaction

    const addressTo = currentTransaction.to
        ? currentTransaction.to.hash
        : currentTransaction.created_contract?.hash
    return (
        <tr className={styles.tableRow}>
            <td className={styles.tdCell}>
                <NavLink
                    to={'/block/' + currentTransaction.block}>
                    {currentTransaction.block}
                </NavLink>
            </td>
            <td className={styles.tdCell}>
                 <p>
                    {getTimeFromTimestamp(currentTransaction.timestamp)}
                </p>
            </td>

            <td className={styles.tdCell}>
                 159
            </td>
            <td className={styles.tdCell}>
                 0.00 TH
            </td>
            <td className={styles.tdCell}>
                <div>12,865,934 (42.89%)</div>
                <div className={styles.lineicon}></div>
            </td>
            <td className={styles.tdCell}>
                1000 DOP
            </td>
        </tr>
    )
}

